import { Dispatch } from 'redux';
import BaseAction from 'src/models/common/BaseAction';
import UserApiController from 'src/api/UserApiController';
import RoleApiController from "src/api/RoleApiController";
import GradeApiController from "src/api/GradeApiController";
import CultureApiController from "src/api/CultureApiController";
import KeyValueListDTO from "src/models/generic/KeyValueListDTO";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import KeyValueDTO from "src/models/generic/KeyValueDTO";
import Languages from "src/constants/Languages";
import FileApiController from "src/api/FileApiController";
import CheckpointApiController from "src/api/CheckpointApiController";
import ConfigDTO from "src/models/misc/ConfigDTO";

export interface UpdateRolesConstantAction extends BaseAction { type: "UPDATE_ROLES_CONSTANTS"; data: KeyValueDTO<string, number>[]; }
export interface UpdateGradesConstantAction extends BaseAction { type: "UPDATE_GRADES_CONSTANTS"; data: KeyValueDTO<string, number>[]; }
export interface UpdateCheckpointsConstantAction extends BaseAction { type: "UPDATE_CHECKPOINTS_CONSTANTS"; data: KeyValueDTO<string, number>[]; }
export interface UpdateLanguagesConstantAction extends BaseAction { type: "UPDATE_LANGUAGES_CONSTANTS"; data: KeyValueDTO<string, number>[]; }
export interface UpdateCultureConstantAction extends BaseAction { type: "UPDATE_CULTURE_CONSTANTS"; data: KeyValueDTO<number, string>[]; }
export interface UpdateConfigConstantAction extends BaseAction { type: "UPDATE_CONFIG_CONSTANTS"; data: ConfigDTO; }
export interface UpdateStateConstantAction extends BaseAction { type: "UPDATE_STATE_CONSTANTS"; data: KnownConstantStates; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = UpdateRolesConstantAction | UpdateGradesConstantAction | UpdateCheckpointsConstantAction | UpdateLanguagesConstantAction | UpdateStateConstantAction | UpdateCultureConstantAction | UpdateConfigConstantAction;

/** Used in the UserReducer */
export type KnownConstantStates = "none" | "loading" | "error" | "finished";

export default class ConstantAction {
    constructor() {
        // Dont be that guy
        throw new Error("NOOOO");
    }

    private static GetRolesPromise(dispatch: Dispatch<ReduxStoreModel>) {
        return RoleApiController.getAllRoles().then(result => {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_ROLES_CONSTANTS", data: result.data } as UpdateRolesConstantAction);
            return true;
        });
    }

    private static GetGradesPromise(dispatch: Dispatch<ReduxStoreModel>) {
        return GradeApiController.getAllGrades().then(result => {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_GRADES_CONSTANTS", data: result.data } as UpdateGradesConstantAction);
            return true;
        });
    }

    private static GetCheckpointsPromise(dispatch: Dispatch<ReduxStoreModel>) {
        return CheckpointApiController.getAllCheckpoints().then(result => {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_CHECKPOINTS_CONSTANTS", data: result.data } as UpdateCheckpointsConstantAction);
            return true;
        });
    }

    private static GetLanguagesPromise(dispatch: Dispatch<ReduxStoreModel>) {
        return CultureApiController.getAllCultures().then(result => {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_LANGUAGES_CONSTANTS", data: result.data } as UpdateLanguagesConstantAction);
            return true;
        });
    }

    private static GetCulturePromise(dispatch: Dispatch<ReduxStoreModel>) {
        return UserApiController.getUserCultures().then(result => {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_CULTURE_CONSTANTS", data: result.data } as UpdateCultureConstantAction);
            return true;
        });
    }

    private static GetConfigPromise(dispatch: Dispatch<ReduxStoreModel>) {
        return FileApiController.getContentUri().then(result => {
            if (!result.ok) {
                return false;
            }
            dispatch({ type: "UPDATE_CONFIG_CONSTANTS", data: result.data } as UpdateConfigConstantAction);
            return true;
        });
    }

    public static LoadConstants(dispatch: Dispatch<ReduxStoreModel>): Promise<boolean> {
        dispatch({ type: "UPDATE_STATE_CONSTANTS", data: "loading" } as UpdateStateConstantAction);

        // Roles
        let rolesFetch = this.GetRolesPromise(dispatch);

        // Grades
        let gradesFetch = this.GetGradesPromise(dispatch);

        // Grades
        let checkpointsFetch = this.GetCheckpointsPromise(dispatch);

        // Languages
        let languagesFetch = this.GetLanguagesPromise(dispatch);

        // User Cultures!
        let culturesFetch = this.GetCulturePromise(dispatch);

        // App Config
        let configFetch = this.GetConfigPromise(dispatch);

        return Promise.all([rolesFetch, gradesFetch, checkpointsFetch, languagesFetch, culturesFetch, configFetch]).then(x => {
            let result: boolean = x.reduce((first, second) => {
                return first && second;
            }, true);

            dispatch({ type: "UPDATE_STATE_CONSTANTS", data: result ? "finished" : "error" } as UpdateStateConstantAction);
            return result;
        });
    }

    /** Because emulation hates you and is complicated */
    public static LoadConstantsEmulation(dispatch: Dispatch<ReduxStoreModel>): Promise<boolean> {
        // User Cultures!
        let culturesFetch = this.GetCulturePromise(dispatch);

        // Not 100% necessary but its consistent with the other related methods
        return Promise.all([culturesFetch]).then(x => {
            let result: boolean = x.reduce((first, second) => {
                return first && second;
            }, true);

            dispatch({ type: "UPDATE_STATE_CONSTANTS", data: result ? "finished" : "error" } as UpdateStateConstantAction);
            return result;
        });
    }
}



// WEBPACK FOOTER //
// ./src/redux/ConstantActions.ts